import React from "react";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
export const CartIcon: React.FC = () => {
  const {
    itemCount
  } = useCart();
  const navigate = useNavigate();
  return <Button variant="ghost" size="lg" onClick={() => navigate("/cart")} className="relative my-0 mx-0">
      <ShoppingCart className="h-10 w-10" /> {/* Increased from h-7 w-7 to h-10 w-10 */}
      {itemCount > 0 && <span className="absolute -top-2 -right-2 bg-tribal-primary text-white text-xs font-medium rounded-full h-6 w-6 flex items-center justify-center py-0 px-0 my-[9px] mx-[12px]">
          {itemCount}
        </span>}
    </Button>;
};